import React from 'react';
import PropTypes from 'prop-types';

import { Badge } from 'react-bootstrap-5';

export default function ShadowDocumentUsageDetails({ shadow }) {
  return (
    <div>
      <table>
        <tbody>
          {shadow.documentUsage.map(usage => (
            <tr key={usage.document.id}>
              <td className="p-2 text-nowrap">
                {usage.document.name}
              </td>

              <td className="page-numbers text-end">
                <Badge bg="muted">
                  Page {usage.pageNumbers.join(', ')}
                </Badge>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

ShadowDocumentUsageDetails.propTypes = {
  shadow: PropTypes.shape({
    documentUsage: PropTypes.arrayOf(PropTypes.shape({
      document: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
      }).isRequired,
      pageNumbers: PropTypes.arrayOf(PropTypes.number).isRequired,
    })).isRequired,
  }).isRequired,
};
